import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout';
import { Landing } from './pages/Landing';
import { Overview } from './pages/Overview';
import { Volunteers } from './pages/Volunteers';
import { Schedule } from './pages/Schedule';
import { Settings } from './pages/Settings';
import { Workforce } from './pages/Workforce';
import { Compliance } from './pages/Compliance';
import { Reports } from './pages/Reports';
import { VolunteerProfile } from './pages/VolunteerProfile';
import { Network } from './pages/Network';
function RequireAuth({
  children
}: {
  children: JSX.Element;
}) {
  // Allow access in the Screens preview context (iframe loads ?mp_screen=...)
  // so gated app pages still render their previews instead of the landing.
  const isScreensPreview = typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('mp_screen');
  const isAuth = isScreensPreview || sessionStorage.getItem('bibde_access') === 'granted';
  const location = useLocation();
  if (!isAuth) {
    return <Navigate to="/" state={{
      from: location
    }} replace data-id="element-0" />;
  }
  return children;
}
export function App() {
  return <BrowserRouter data-id="element-1">
      <Routes data-id="element-2">
        <Route path="/" element={<Landing data-id="element-4" />} data-id="element-3" />
        <Route element={<RequireAuth data-id="element-6">
              <AppLayout data-id="element-7" />
            </RequireAuth>} data-id="element-5">
          <Route path="dashboard/overview" element={<Overview data-id="element-9" />} data-id="element-8" />
          <Route path="dashboard/volunteers" element={<Volunteers data-id="element-11" />} data-id="element-10" />
          <Route path="dashboard/volunteers/:id" element={<VolunteerProfile data-id="element-13" />} data-id="element-12" />
          <Route path="dashboard/schedule" element={<Schedule data-id="element-15" />} data-id="element-14" />
          <Route path="dashboard/settings" element={<Settings data-id="element-17" />} data-id="element-16" />
          <Route path="workforce" element={<Workforce data-id="element-19" />} data-id="element-18" />
          <Route path="compliance" element={<Compliance data-id="element-21" />} data-id="element-20" />
          <Route path="reports" element={<Reports data-id="element-23" />} data-id="element-22" />
          <Route path="network" element={<Network data-id="element-25" />} data-id="element-24" />
        </Route>
      </Routes>
    </BrowserRouter>;
}